// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"40e7cfca","390":"edbdc4e2","453":"2111b4de","553":"656df5a3","990":"1c12b37d"}[chunkId] + ".chunk.js";
};